<template>
  <div>
    <search-sale-agent-monthly-performance
      statistic-type="additional"
      @submit="submitSearch"
    />

    <a-table
      :scroll="{ x: 'max-content' }"
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :expand-icon="expandIcon"
      :row-class-name="rowClassName"
      row-key="id"
    >
      <div slot-scope="record" slot="expandedRowRender">
        <a-table
          size="middle"
          :pagination="false"
          :columns="costGroupColumns(record)"
          :data-source="record.cost_groups || []"
          row-key="rowKey"
        />
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchSaleAgentMonthlyPerformance from '@/views/sale_monthly_performances/info/Search'
import { findSaleAgentMonthlyAdditionalPerformances } from '@/api/sale_monthly_performance'
import { formatCurrency, formatBigNumber } from '@/utils/filter'
import { canViewSaleCostProfit } from '@/utils/sale_monthly_performance'

export default {
  name: 'SaleMonthlyPerformanceInfoAdditionalList',
  components: {
    Pagination,
    SearchSaleAgentMonthlyPerformance
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    canViewCostProfit() {
      return canViewSaleCostProfit(this.$store.getters.userRole)
    },
    columns() {
      const cols = [
        {
          title: '客户名称',
          dataIndex: 'agent_name'
        },
        {
          title: '账单类型',
          dataIndex: 'bill_type'
        },
        {
          title: '项目批次',
          dataIndex: 'agent_bill_no'
        },
        {
          title: '账单金额(元)',
          customRender: formatCurrency,
          dataIndex: 'amount'
        }
      ]
      if (this.canViewCostProfit) {
        cols.push(
          {
            title: '成本核算(元)',
            customRender: formatCurrency,
            dataIndex: 'cost'
          },
          {
            title: '毛利核算(元)',
            customRender: formatCurrency,
            dataIndex: 'profit'
          }
        )
      }
      cols.push(
        {
          title: '卡板费用(元)',
          customRender: formatCurrency,
          dataIndex: 'card_amount'
        },
        {
          title: '套餐费用(元)',
          customRender: formatCurrency,
          dataIndex: 'product_amount'
        },
        {
          title: 'eSIM费用(元)',
          customRender: formatCurrency,
          dataIndex: 'esim_amount'
        },
        {
          title: 'Profile费用(元)',
          customRender: formatCurrency,
          dataIndex: 'profile_amount'
        },
        {
          title: '模组费用(元)',
          customRender: formatCurrency,
          dataIndex: 'module_amount'
        },
        {
          title: 'CPE费用(元)',
          customRender: formatCurrency,
          dataIndex: 'cpe_amount'
        },
        {
          title: '卡数',
          dataIndex: 'cards_count'
        },
        {
          title: 'eSIM数量',
          dataIndex: 'esims_count'
        },
        {
          title: 'Profile数量',
          dataIndex: 'profiles_count'
        },
        {
          title: '模组数量',
          dataIndex: 'modules_count'
        },
        {
          title: 'CPE数量',
          dataIndex: 'cpes_count'
        },
        {
          title: '账单时间',
          dataIndex: 'agent_bill_time'
        }
      )
      return cols
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findSaleAgentMonthlyAdditionalPerformances(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = (res.data || []).map((row) => {
            const groups = (row.cost_groups || []).map((g, gi) => ({
              ...g,
              rowKey: `${row.id}-${g.supplier_id}-${g.product_model_id || 0}-${g.unit_price}-${gi}`
            }))
            return {
              ...row,
              cost_groups: row.cost_groups ? groups : undefined
            }
          })
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    costGroupColumns(record) {
      const cols = [
        {
          title: '供应商',
          dataIndex: 'supplier_name'
        }
      ]
      if (record.bill_type === '模组采购账单' || record.bill_type === 'CPE采购账单') {
        cols.push({
          title: '产品型号',
          dataIndex: 'product_model_name'
        })
      }
      cols.push(
        {
          title: '成本单价(元)',
          customRender: formatCurrency,
          dataIndex: 'unit_price'
        },
        {
          title: '数量',
          customRender: formatBigNumber,
          dataIndex: 'count'
        },
        {
          title: '成本小计(元)',
          customRender: formatCurrency,
          dataIndex: 'cost_subtotal'
        }
      )
      return cols
    },

    rowClassName(record) {
      if (this.canViewCostProfit && record.profit != null && Number(record.profit) < 0) {
        return 'sale-profit-negative-row'
      }
      return ''
    },

    expandIcon({ expanded, expandable, record, onExpand }) {
      if (!this.canViewCostProfit || !Array.isArray(record.cost_groups)) {
        return null
      }
      return (
        <a onClick={e => onExpand(record, e)}>
          {expanded ? <a-icon type='minus-square' /> : <a-icon type='plus-square' />}
        </a>
      )
    }
  }
}
</script>

<style>
.sale-profit-negative-row td {
  color: #f5222d !important;
}
</style>
